import React from 'react';
import Button from './Button';
import CompetitionTypePill from './CompetitionTypePill';
import CompetitionModePill from './CompetitionModePill';
import CompetitionVisibilityPill from './CompetitionVisibilityPill';
import CompetitionPrizePill from './CompetitionPrizePill';
import { EvaluationSummary } from '../../types/interfaces';

interface EvaluationCardProps {
  evaluation: EvaluationSummary;
}

const EvaluationCard: React.FC<EvaluationCardProps> = ({ evaluation }) => {
  const statusClass = (evaluation.status || 'default').toLowerCase().replace(/\s+/g, '-');
  const votesLeft = Math.max(evaluation.max_votes - evaluation.current_votes, 0);

  return (
    <div className="evaluation-card">
      <div className="evaluation-card__header">
        {evaluation.logo_path && (
          <img
            src={`${evaluation.logo_path}`}
            alt={`${evaluation.title} logo`}
            className="evaluation-card__logo"
          />
        )}
        <div className="evaluation-card__title-group">
          <h4>{evaluation.title}</h4>
          <div className="competition-card__badges">
            <span className={`dashboard__competition-status dashboard__competition-status--${statusClass}`}>
              {evaluation.status}
            </span>
            <CompetitionTypePill type={evaluation.type} titlePrefix="Evaluation type" />
            <CompetitionModePill mode={evaluation.competition_mode} />
            <CompetitionVisibilityPill visibility={evaluation.visibility} />
            <CompetitionPrizePill prize={evaluation.prize} />
          </div>
        </div>
      </div>
      <div className="evaluation-card__stats">
        <div>
          <span className="evaluation-card__label">Total Votes</span>
          <strong>{evaluation.max_votes}</strong>
        </div>
        <div>
          <span className="evaluation-card__label">Votes Used</span>
          <strong>{evaluation.current_votes}</strong>
        </div>
        <div>
          <span className="evaluation-card__label">Votes Left</span>
          <strong>{votesLeft}</strong>
        </div>
      </div>
      <div className="evaluation-card__label">
        <Button variant="outline" size="sm" onClick={() => window.location.href = `/evaluations/${evaluation.competition_id}`}>
          Evaluate
        </Button>
      </div>
    </div>
  );
};

export default EvaluationCard;
